import type { SlimOrganization } from '@ilteducation/my-account-types';

export const getActiveOrganizationsIds = (organizations: SlimOrganization[]): string[] => {
  const activeOrgsIds = new Set<string>();

  for (const org of organizations) {
    // Skip if the organization itself is inactive or lacks a UID.
    if (!org.active || !org.uid) {
      continue;
    }

    // Skip if the organization has a parent AND that parent is NOT active.
    if (org.parent && !org.parent.active) {
      continue;
    }

    // Add the active organization's UID.
    activeOrgsIds.add(org.uid);

    // Add the Parent. if org.parent exists, we know it is active.
    if (org.parent) {
      activeOrgsIds.add(org.parent.uid);
    }
  }

  return Array.from(activeOrgsIds);
};
